export type DeletionRequestStatus =
  | "pending"
  | "processing"
  | "rejected"
  | "cancelled"
  | "completed"

/** Mirrors `DeletionRequestSerializer.REASON_CHOICES`; the self-serve modal
 *  renders the list, the admin table renders whatever id a row carries. */
export const REASON_IDS = [
  "leaving_company",
  "duplicate_account",
  "privacy_concerns",
  "no_longer_using",
  "organization_request",
  "other"
] as const

export type DeletionReasonId = (typeof REASON_IDS)[number]

export interface DeletionRequestUser {
  id: string
  name: string
  email: string
}

export interface AccountDeletionRequest {
  id: string
  user: DeletionRequestUser
  status: DeletionRequestStatus
  reason_id: DeletionReasonId
  reason_text?: string
  created_at: string
  decided_at?: string
  escalation_reminded_at?: string
}
